import { Component, OnInit } from '@angular/core';
import { tap } from 'rxjs/operators';
import { MmTranslateService } from '../translate.service';

@Component({
  selector: 'mm-lang-switch',
  templateUrl: './lang-switch.component.html',
  styleUrls: ['./lang-switch.component.scss']
})
export class LangSwitchComponent implements OnInit {

  constructor(private translateService: MmTranslateService) {

  }

  ngOnInit(): void {

  }

  

  get language() {

    return this.translateService.currentLang;
  }
  selectLang(lang: string) {
  
    this.translateService.use(lang)
      .pipe(
        tap(() => 
        {
          window.location.reload()
        })
      )
      .subscribe();
  }

}
